<template>
    <div id="patent-view" class="w-100 h-100 position-relative">
        <!-- Global cover loading while fetching patent -->
        <div class="patent-view-container display-flex">
            <AonCoverLoading :loading="loadingDetails" title="Loading Patent Data..." />
            <div class="patent-side-panel p-md">
                <PatentHeader
                    ref="highLevelRef"
                    :patentDetails="patentViewerStore.patentDetails || {}"
                    inline
                />
            </div>
            <div class="patent-main-panel">
                <PatentDetails inline :hideMappedProducts="true" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, inject, computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { usePatentViewerStore } from '@/stores'

import { getPatentDetails } from '@/api/patentViewer'

import PatentDetails from '@/components/patentViewer/PatentDetails.vue'
import PatentHeader from '@/components/patentViewer/patentDetailComponents/PatentHeader.vue'

// Pinia store for patent data
const patentViewerStore = usePatentViewerStore()
const route = useRoute()
const router = useRouter()
const logger = inject('logger')

const loadingDetails = ref(true)

const loadPatent = async (patentId) => {
    if (!patentId) {
        router.back()
        return
    }

    loadingDetails.value = true
    patentViewerStore.resetState()
    patentViewerStore.patentDetailsOpen = false

    await patentViewerStore.setTargetPatent(patentId)
    loadingDetails.value = false
}

watch(
    () => route.params.patentId,
    async (newPatentId, oldPatentId) => {
        if (newPatentId && newPatentId !== oldPatentId) {
            await loadPatent(newPatentId)
        }
    }
)

onMounted(async () => {
    const patentId = route.params.patentId
    await loadPatent(patentId)
})

onBeforeUnmount(() => {
    patentViewerStore.resetState()
})
</script>

<style scoped lang="scss">
#patent-view {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: var(--color-stone-50);

    .patent-side-panel {
        width: 350px;
        border-right: 1px solid var(--color-stone-300);

        :deep(.high-level) {
            margin-top: -16px;
            background-color: var(--color-stone-50);
            .left-details {
                p {
                    font-size: 12px;
                }

                .divide {
                    margin: 0 8px !important;
                }
            }
        }

        :deep(.info-container) {
            margin-top: 20px;

            .assignee {
                // .display-flex {
                //     flex-wrap: wrap;
                // }
                .no-wrap {
                    width: 100% !important;
                }
            }
        }
    }

    :deep(.patent-details) {
    }
}
</style>
